// src/features/operational/components/assessment/Assessment.js
import React, { useState } from 'react';
import { 
  Box, 
  Paper, 
  Tabs, 
  Tab, 
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {
  Assignment as POAIcon,
  FormatListNumbered as MarksIcon
} from '@mui/icons-material';
import { THEME_COLORS } from '../../../../styles/theme';
import ProgrammeOfAssessment from './ProgrammeOfAssessment';
import TaskMarkList from './TaskMarkList';

const Assessment = () => {
  const [activeTab, setActiveTab] = useState('poa');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  
  const renderContent = () => {
    switch (activeTab) {
      case 'poa':
        return <ProgrammeOfAssessment />;
      case 'marks':
        return <TaskMarkList />;
      default:
        return <ProgrammeOfAssessment />;
    }
  };
  
  return (
    <Box>
      <Paper 
        elevation={2} 
        sx={{ 
          p: 2, 
          mb: 3, 
          borderRadius: 2
        }}
      >
        <Typography variant="h6" fontWeight="bold" color={THEME_COLORS.primary} mb={2}>
          Assessment Management
        </Typography>
        
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant={isMobile ? "scrollable" : "fullWidth"}
          scrollButtons={isMobile ? "auto" : false}
          indicatorColor="primary"
          textColor="primary"
          sx={{
            '& .MuiTab-root': {
              minHeight: 48,
              textTransform: 'none',
              fontWeight: 600
            },
            '& .Mui-selected': {
              color: THEME_COLORS.primary
            },
            '& .MuiTabs-indicator': {
              backgroundColor: THEME_COLORS.primary
            }
          }}
        >
          <Tab 
            icon={<POAIcon />} 
            iconPosition="start" 
            label="Programme of Assessment" 
            value="poa" 
          />
          <Tab 
            icon={<MarksIcon />} 
            iconPosition="start" 
            label="Task Mark Lists" 
            value="marks" 
          />
        </Tabs>
      </Paper>
      
      {/* Render the content based on active tab */}
      <Box>
        {renderContent()}
      </Box>
    </Box>
  );
};

export default Assessment;
